import { render, staticRenderFns } from "./adminoverview-component.vue?vue&type=template&id=614e0e61"
import script from "./adminoverview-component.vue?vue&type=script&lang=ts"
export * from "./adminoverview-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports